// removed by extract-text-webpack-plugin
module.exports = {"slider":"slider__y9cJH","slider_inner":"slider_inner__2JQKR","slider_slides":"slider_slides__2__M-","slider_slides__transition":"slider_slides__transition__1t2qo","slider_nav":"slider_nav__3EUTG","slider_navButton":"slider_navButton__3URIC","slider_navButton__active":"slider_navButton__active__32JYT","slider__textPage":"slider__textPage__2-6aQ"};


//////////////////
// WEBPACK FOOTER
// ./hocs/Slider/Slider.scss
// module id = kXWF
// module chunks = 0